<template>
  <div class="admin-withdraw">
    <page-title title="筛选">
      <el-row :gutter="20" class="admin-withdraw__filter-header">
        <el-col :xl="5" :span="8">
          <span>店铺名称：</span>
          <el-input v-model="filter.storeName" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="8">
          <span>手机号：</span>
          <el-input v-model="filter.phone" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="8">
          <span>提现状态：</span>
          <el-select clearable v-model="filter.status" placeholder="请选择">
            <el-option v-for="s in status" :value="s" :label="status_zh[s]" :key="s"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="8" :span="8">
          <span>提现申请时间区间：</span>
          <el-date-picker
            v-model="dataRange"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :xl="3" :span="8">
          <el-button @click="getList">查询</el-button>
          <el-button @click="filter = { createdDate: '' };getList()">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="admin-withdraw__body">
        <el-table :data="withdrawData" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7` }" v-loading="loading">
          <el-table-column type="index" width="90" align="center"> </el-table-column>
          <el-table-column prop="storeAsset.store.name" label="店铺名称" width="235"> </el-table-column>
          <el-table-column prop="bankCard.phone" label="手机号" width="145"> </el-table-column>
          <el-table-column prop="bankCard.number" label="提现账号" width="225"> </el-table-column>
          <el-table-column prop="amount" label="提现金额" width="130"> </el-table-column>
          <el-table-column label="提现状态" width="160">
            <template slot-scope="{ row }">
              <withdraw-state-label :status="row.status"></withdraw-state-label>
            </template>
          </el-table-column>
          <!-- <el-table-column label="提现状态" width="145">
            <template slot-scope="{ row }">
              <withdraw-state-label :status="row.state"></withdraw-state-label>
            </template>
          </el-table-column> -->
          <el-table-column prop="createdDate" label="提现申请时间" width="230"> </el-table-column>
          <el-table-column label="提现处理时间" width="230">
            <template slot-scope="{ row }">
              <span>
                {{ row.transferTime || '- -' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="70">
            <template slot-scope="{ row }">
              <router-link style="text-decoration:none;color:#005BFF;" :to="`/withdraw/${row.id}`">
                <span>详情</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize"></cus-pagination>
    </page-title>
  </div>
</template>
<script>
import PageTitle from '@/components/pageTitle.vue';
import CusPagination from '@/components/cusPagination.vue';
import VertifyStateLabel from './components/vertifyStateLabel.vue';
import WithdrawStateLabel from './components/withdrawStateLabel.vue';
import { getWithdrawList } from '@/api/req';
import { STATUS, STATUS_ZH } from './_eum';

export default {
  name: 'withdraw',
  components: {
    PageTitle,
    CusPagination,
    WithdrawStateLabel,
    VertifyStateLabel
  },
  data() {
    return {
      loading: false,
      filter: {
        createdDate: ''
      },
      withdrawData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: {
    status() {
      return STATUS;
    },
    status_zh() {
      return STATUS_ZH;
    },
    dataRange: {
      get() {
        return this.filter.createdDate.split(',');
      },
      set(val) {
        this.filter.createdDate = val ? val.join(',') : '';
      }
    }
  },
  watch: {
    currentPage() {
      this.getList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      const req = { ...this.filter, pageSize: this.pageSize, pageNumber: this.currentPage };
      this.$ajax
        .get(getWithdrawList, req)
        .then(res => {
          this.loading = false;
          this.withdrawData = Object.freeze(res.data.rows);
          this.total = res.data.total;
        })
        .catch(err => {
          this.loading = false;
          console.log(err.data);
        });
    }
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== '{}') {
      this.filter = Object.assign(this.filter, query);
    }
    this.getList();
  }
};
</script>

<style lang="scss">
.admin-withdraw {
  &__filter-header {
    .el-date-editor {
      position: relative;
      padding-right: 25px;
      .el-icon-date {
        position: absolute;
        right: 0;
        line-height: 38px;
      }
    }
  }
  &__body {
    margin-bottom: 16px;
    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      .el-icon-circle {
        margin-right: 6px;
        vertical-align: middle;
      }
    }
    .el-switch__label {
      color: #8998a0;
    }
    .el-switch__label.is-active {
      color: #005bff;
    }
  }
}
</style>
